import React from 'react';

const AffirmPaymentSvg = (props) => (
    <svg viewBox="0 0 48 32" {...props}>
        <path
            fill="#00C8E5"
            d="M0 3c0-1.6 1.4-3 3-3h42c1.7 0 3 1.4 3 3v26c0 1.6-1.3 3-3 3H3c-1.6 0-3-1.4-3-3V3z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFF"
            d="M12.7 21.7v-7.3c0-.6-.5-1.1-1.1-1.2-.4 0-.8.1-1.1.4l-6.3 8h1.6c.6 0 1.1-.3 1.5-.8l3.5-4.4v5.2h1.9zm8.6-9c0-.3 0-.6.3-.8.3-.2.6-.2.9-.1l.4-1.5h-.2c-.9 0-1.8-.1-2.5.4-.6.4-.9 1.2-.9 1.9v.9h-2.5v-.8c0-.3 0-.6.3-.8.3-.2.6-.2.9-.1l.4-1.5h-.2c-.9 0-1.8-.1-2.6.4-.6.4-.9 1.1-.9 1.9v.9h-.9V15h.9v6.7h2.1V15h2.5v6.7h2.1V15h1.4v-1.5h-1.4v-.8zm19.2.6c-.9 0-1.7.3-2.2.9-.6-.6-1.3-.9-2.2-.9-1.9 0-3.3 1.4-3.3 3.3v5.1h2v-5.2c0-.8.5-1.3 1.2-1.3.8 0 1.2.5 1.2 1.3v5.2h2v-5.2c0-.8.5-1.3 1.2-1.3.8 0 1.2.5 1.2 1.3v5.2h2v-5.1c.2-1.9-1.2-3.3-3.1-3.3zm-8.4 0c-1 0-2.2.7-2.6 1.7v-1.5h-2v8.2h2.1v-3.8c0-1.6.6-2.5 2-2.5l1.2-2c-.2-.1-.6-.1-.7-.1zm-8.3 8.4h2.1v-8.2h-2.1v8.2zm1.1-11.4c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2 1.2-.5 1.2-1.2-.6-1.2-1.2-1.2z"
        />
    </svg>
);

AffirmPaymentSvg.displayName = 'AffirmPaymentSvg';
export default AffirmPaymentSvg;
